import { createFileRoute } from '@tanstack/react-router';

import { ChatPage } from '../_pages';

export const Route = createFileRoute('/')({
  component: ChatPage,
});
